import { Link } from "react-router-dom";

const points = [
  {
    icon: "ri-search-eye-line",
    title: "精准搜索",
    desc: "输入关键词即可在前端快速匹配网站名称、简介与标签。",
  },
  {
    icon: "ri-apps-line",
    title: "分类浏览",
    desc: "十大热门分类清晰归类，按场景快速找到需要的网站。",
  },
  {
    icon: "ri-flashlight-line",
    title: "一键直达",
    desc: "所有入口均直接跳转至目标网站，没有中间页，访问更高效。",
  },
];

export default function BrandIntro() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-compass-3-line"></i>
              关于网址导航
            </span>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">
              为高效上网而生的网址导航平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              网址导航面向互联网普通用户、职场办公人群与学生，通过分类与精选方式提供丰富且最新的热门网站入口。
              我们持续整理、更新优质站点，帮助你在海量信息中快速定位，节省搜索时间、提高访问效率。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>

          <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-1">
            {points.map((p) => (
              <div
                key={p.title}
                className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{p.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}